import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { css } from '@linaria/core'
import { styled } from '@linaria/react'
import { Link } from '@tanstack/router'
import { useTranslation } from 'react-i18next'

import { useBoundStore } from '../../store/store'
import closeModal from '../../utils/closeModal'
import Modal from '../common/modal'
import Icon from '../icon'

const container = css`
  width: calc(100% - 32px);

  @media (min-width: 1200px) {
    max-width: 450px;
  }
`

const Title = styled.h3`
  font-weight: 900;
  font-size: 20px;
  color: var(--txt);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  svg {
    margin-right: 10px;
  }
  @media (min-width: 1200px) {
    font-size: 24px;
    svg {
      width: 35px;
      height: 35px;
    }
  }
`

const Text = styled.p`
  font-weight: 400;
  font-size: 15px;
  color: var(--txt);
  text-align: center;
  margin-bottom: 24px;
  @media (min-width: 1200px) {
    font-size: 17px;
  }
`

const Proceed = styled.button`
  text-align: center;
  font-size: 18px;
  width: max-content;
  padding: 7px 36px;
  background-color: var(--primary-btn-bg);
  border: 1.5px solid var(--primary-btn-bg);
  color: var(--primary-btn-txt);
  border-radius: 22px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  font-weight: 400;
  margin: 0 auto;
  display: block;
  @media (min-width: 1200px) {
    font-size: 20px;
    padding: 10px 0;
    width: 170px;
    border-radius: 26px;
  }
`

const UnsuccessfulVerificationModal = () => {
  const verif_request_comment = useBoundStore(
    state => state.user.verif_request_comment,
  )
  const modal = useModal()
  const { t } = useTranslation('kyc')

  return (
    <Modal id="unsuccessful-verification-modal" containerStyle={container}>
      <Title>
        <Icon id="exclamation-circle" width="30" height="30" />
        {t('unsuccessful-verification')}
      </Title>
      <Text>
        {t('remarks')}: {verif_request_comment}
      </Text>
      <Link to="/profile/kyc">
        <Proceed onClick={() => closeModal(modal)}>{t('proceed')}</Proceed>
      </Link>
    </Modal>
  )
}

export default NiceModal.create(UnsuccessfulVerificationModal)
